// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M2LUJqZpwgAOzKGo7lNd{flex-direction:column;flex-grow:1;width:760px;margin:0 auto;display:flex}.AZwdHweIH90ltg6uyzgz{flex-direction:column;gap:4px;display:flex}.VS0SRnAQuFgkLdT6pIiW{text-align:center;margin-bottom:4px}.nZKTZsJohycvgMqdPoDo{flex-direction:column;gap:16px;height:100%;padding:32px 11px 0 15px;display:flex}.vPDEiBKkPmgL8PIux2y4{margin:0 7px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `M2LUJqZpwgAOzKGo7lNd`,
	"inboxesDetailsHeader": `AZwdHweIH90ltg6uyzgz`,
	"createInboxText": `VS0SRnAQuFgkLdT6pIiW`,
	"navBar": `nZKTZsJohycvgMqdPoDo`,
	"navBarTabs": `vPDEiBKkPmgL8PIux2y4`
};
export default ___CSS_LOADER_EXPORT___;
